module.exports = __WEBPACK_EXTERNAL_MODULE_tripartite__;